import React from "react";
import "./App.css"
import LEDRing from "./LEDRing";
import "./Wheel"
import { getData } from "./services/gardone";
import { type } from "@testing-library/user-event/dist/type";
import confetti from 'canvas-confetti';


class Wheel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            rotation: 0,                //زاویه رو نگه میداره که وقتی مجدد روی دکمه چرخش زدیم از همونجایی که هست شرو به چرخش کنه
            isSpinning: false,          // ایا درحال چرخش است اینطوری باعث میشه که دوباره دکمه چرخش رو نزنی که باگ بگیره
            showWinnerModal: false,     //ایا پنجره برنده نمایش داده میشود
            winnerText: '',             //اسم بخش برنده
            winnerQuestion: '',         //سوال کامل
            segments: [],
            winnerIcon: null
        }
        this.canvasRef = React.createRef();
        this.confettiContainer = React.createRef();//شرشره

    }


    componentDidMount() {
        const getGardone = async () => {
            const res = await getData();//اینجا تابع رو صدا میزنیم و منتظر میمونیم تا داده از سرور بیاد
            // console.log(res);

            //فرض بر این که res یک ارایه از سوالات است
            const allQuestions = Array.isArray(res) ? res : res.categories || [];//ساختار داده رو بررسی میکنه تا مطمئن شه ارایه هست
            //انتخاب 6 سوال تصادفی
            const shuffled = [...allQuestions].sort(() => 0.5 - Math.random());//ارایه رو به صورت تصادفیمرتب میکنه عدد تصادفی بین 0 و 1 و 0.5 - random باعث میشه ترتیب بهم بریزه
            const selectedSegments = shuffled.slice(0, 6)  //از ارایه تصادفی 6 عنصر اول رو انتخاب کن

            //تبدیل داده ها به فرمت مناسب برای چرخ
            const segmentsData = selectedSegments.map((q, index) => ({
                id: q.id,
                text: [q.text],
                label: q.text.substring(0, 15),
                color: `hsl(${index * 60}, 70%, 50%)`,
                type: q.type,
                status: q.status
            }));

            //بروز رسانی state و segments رو با داده های جدید تنظیم میکنه
            this.setState({
                segments: segmentsData
            }, () => {    //یک کال بک است ببعد از بروزرسانی با اطلاعات جدید گردونه رو میکشه
                this.drawWheel();
            });
        }

        getGardone();


    }


    drawWheel = () => {
        const canvas = this.canvasRef.current;               //دسترسی به المان کنوس
        if (!canvas) return;                                 //اگر به هر دلیلی کنوسی وجود نداشت مثلا رندر نشده از تابع خارج شو

        // مهم: اگر داده‌ها هنوز نیومدن، گردونه رو نکش
        if (this.state.segments.length === 0) return;


        const ctx = canvas.getContext('2d');                 //ابزار نقاشی رو از کنوس میگیره میزاره تو متغییر
        const size = 450;
        ctx.clearRect(0, 0, size, size);                     // از گوشه 0و0 تا 400و400زصفحه کنوس رو پاک میکنه    
        // وقتی گردونه میچرخه، هر بار باید دوباره کشیده بشه. پس اول صفحه رو پاک میکنیم تا تصویر قبلی رو پاک کنه.


        const centerX = size / 2;
        const centerY = size / 2;
        const radius = size / 2 - 10;                                             //شعاع دایره
        const anglePerSegment = (2 * Math.PI) / this.state.segments.length;             //زاویه هر بخش

        this.state.segments.forEach((segment, index) => {
            const startAngle = index * anglePerSegment + this.state.rotation;     //زاویه شروع هربخش
            const endAngle = startAngle + anglePerSegment;

            //رسم بخشها
            ctx.beginPath();                                                      //شروع یکم مسیر جدید
            ctx.moveTo(centerX, centerY);                                         // برو به مرکز گردونه
            ctx.arc(centerX, centerY, radius, startAngle, endAngle);              //قوس بکش
            ctx.closePath();                                                      //به مرکز برگرد


            //رنگ
            ctx.fillStyle = segment.color;
            ctx.fill();

            //خطوط جداکننده
            ctx.strokeStyle = '';
            ctx.lineWidth = 0.5;
            ctx.stroke();

            //نوشتن اسم بخشها
            ctx.save();                                            // وضعیت فعلی رو ذخیره کن
            ctx.translate(centerX, centerY);                       //مرکز رو ببر وسط گردونه
            ctx.rotate(startAngle + anglePerSegment / 2);          //بچرخ به اندازه وسط بخش
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle'
            ctx.fillStyle = '#fff';

            //برای گرفتن چند کلمه اول
            let shortText = '';//برای ذخیره نسخه خلاصه شده متن که توی گردونه نشون میده
            if (segment.text && segment.text.length > 0) {
                const fullText = Array.isArray(segment.text) ? segment.text[0] : segment.text;//برسی میکنه که ای segment.text  یک ارایه هست؟ اگر بوود ولین عنصر ارایه را برمیدارد اگر ارایه نبود خودش روبرمیگردونه 
                const words = fullText.split('');// رشته رو با فاصله "" تقسیم میکنه و یک ارایه از کلمات میسازه
                const firstWords = words.slice(0, 10).join('');
                shortText = words.length > 3 ? '...' + firstWords : firstWords;
            }
            ctx.font = 'bold 26px Dana, sans-serif';
            ctx.fillText(shortText, radius * 0.55, 0);         //نوشتن متن در 40 درصد شعاع
            ctx.restore();                                        //وضعیت قبلی را برگردان
        });


        //رسم مرکز گردونه
        ctx.beginPath();
        ctx.arc(centerX, centerY, 25, 0, 2 * Math.PI);                               //یک دایره به مرکز (centerX, centerY) و شعاع 25 رسم میکنه.
        ctx.fillStyle = 'radial-gradient(circle at 35% 35%, #fff, #94a3b8)';       //35% 35% یعنی مرکز گرادینت کمی به سمت بالا و چپ متمایل شده تا جلوه نور خورده برجسته تری ایجاد کند
        ctx.fill();
        ctx.shadowColor = 'rgba(255,255,255,0.9)';
        ctx.shadowBlur = 50;
        ctx.fillStyle = 'radial-gradient(circle at 50% 20%, #fff, #94a3b8)';                                                //دوباره یک دایره با این رنگ میکشه چرا تکرار؟ چون میخوایم هم سایه داشته باشیم (که توسط shadowColor و shadowBlur ایجاد میشه) و هم رنگ پر کردن مشخص باشد.
        ctx.shadowOffsetY = -6;

        ctx.fill();
        ctx.shadowBlur = 10;                                                        //سایه رو غیرفعال میکنه تا روی نوشته ی بعدی اثر نگذارد
        ctx.shadowColor = 'transparent';
        ctx.shadowOffsetY = 0;

        ctx.fillStyle = '#1e293b';
        ctx.font = '20px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';                                               //این دستور و دستور بالا باعث میشه ایکون در مرکز قرار بگیره
        ctx.fillText('🎯', centerX, centerY + 2);                                 //این تابع برای نوشتن متنه




    }
    spinWheel = () => {
        if (this.state.isSpinning) return;
        this.setState({ isSpinning: true });

        const extraSpin = 18;
        const startRotation = this.state.rotation;
        const targetRotation = startRotation + extraSpin * 2 * Math.PI + Math.random() * 2 * Math.PI;

        const duration = 2000;
        const startTime = Date.now();
        let lastRotation = startRotation;

        const finish = (finalRotation) => {
            this.setState({ rotation: finalRotation, isSpinning: false }, () => {
                this.drawWheel();
                this.detectWinner();
            });
        };

        const animate = () => {
            const elapsed = Date.now() - startTime;
            const progress = Math.min(elapsed / duration, 5);
            const eased = 1 - Math.pow(1 - progress, 2);

            const currentRotation = startRotation + (targetRotation - startRotation) * eased;
            this.setState({ rotation: currentRotation }, () => this.drawWheel());

            const delta = Math.abs(currentRotation - lastRotation);
            lastRotation = currentRotation;

            // اگر عملاً حرکت محسوسی نمونده، همینجا تمومش کن (به‌جای صبر تا انتهای duration)
            if (progress >= 1 || (progress > 0.85 && delta < 0.0008)) {
                finish(progress >= 1 ? targetRotation : currentRotation);
                return;
            }
            requestAnimationFrame(animate);
        };

        animate();
    };


    // مشخص میکنه کدام ببخش در جلوی گردونه است
    detectWinner = () => {
        const pointerAngle = -Math.PI / 2;                                      //زاویه عقربه رو مشخص میکنه یعنی -90 درجه دقیقا بالای صحه عدد 12
        const rotation = this.state.rotation;                                   //زاویه فعلی گردونه رو از استیت میگیره یعنی گردونه الان چقدر چرخیده

        const rawAngle = (pointerAngle - rotation) % (2 * Math.PI);             //زاویه نسبی عقربه نسبت به گردون رو حیاب میکنه....باقیمانده رو محاسبه میکنه تا زاویه در محدوده 0 تا 360 درجه بمونه
        const normalizedAngle = ((rawAngle % (2 * Math.PI)) + 2 * Math.PI);     // زاویه rawAngle رو به یک عدد مثبت بین 0 تا 360 درجه تبدیل میمکند 

        const anglePerSegment = (2 * Math.PI) / this.state.segments.length;
        const winnerIndex = Math.floor(normalizedAngle / anglePerSegment);      //تشخیص میده که زاویه normalizedAngle در کدام بخش تیکه ها قرار داره
        const safeIndex = winnerIndex % this.state.segments.length;             //اگر به دلبل باگ ایندکس از لیست بیشتر شد یک ایندکس امن بگیر


        // متد فلور برای گرد کردن عدد اععشاری
        const winnerSegment = this.state.segments[safeIndex];                       //بخش برنده رو از ارایه سگمنت انتخاب میکنه ......از لیست فیلتر شده انتخاب کن

        //اگر همچیز درست بود و روی بخش فیلتر شده ایستاده بود همینجا برنده رو اعلام کن
        this.showWinnerResult(winnerSegment);

    };

    //یک تابع کمکی برای نمایش برنده
    showWinnerResult = (winnerSegment) => {
        if (!winnerSegment || !winnerSegment.text || winnerSegment.text.length === 0) {
            console.warn("سوالی برای این بخش وجود ندارد!");
            return;
        }
        const randomIndex = Math.floor(Math.random() * winnerSegment.text.length);    // انتخاب یک سوال تصادفی از بخش برنده
        const selectQuestion = winnerSegment.text[randomIndex];

        //ترکیب جمله نیمه تمام با سوال کامل
        const fullQuetion = ` ${selectQuestion}`;




        const getWinnerIcon = (type, status) => {
            const key = `${type}_${status}`;
            switch (key) {
                case '1_1':
                    return require('./icon/J1.png');
                case '1_2':
                    return require('./icon/J2.png');
                case '2_1':
                    return require('./icon/h2.png');
                case '2_2':
                    return require('./icon/h1.png');
                default:
                    return require('./icon/333.png')
            }
        };

        const iconPath = getWinnerIcon(winnerSegment.type, winnerSegment.status)

        this.setState({
            showWinnerModal: true,
            winnerText: winnerSegment.label,
            winnerQuestion: fullQuetion,
            winnerIcon: iconPath
        })
        this.fireConfetti();

    }






    closeWinnerModal = () => {
        this.setState({ showWinnerModal: false });
        // وقتی مودال بسته شد، همه شراره‌های باقی‌مانده را پاک کن
        if (this.confettiContainer.current) {
            this.confettiContainer.current.innerHTML = '';
        }
    }



    // تابع پخش شراره‌ها (با روش DOM خالص)
    fireConfetti = () => {
        const container = this.confettiContainer.current;
        if (!container) return;

        const cols = ['#fbbf24', '#ef4444', '#8b5cf6', '#3b82f6', '#10b981', '#ec4899', '#f97316', '#06b6d4'];

        for (let i = 0; i < 80; i++) {
            setTimeout(() => {
                const el = document.createElement('div');

                el.style.position = 'fixed';
                el.style.top = '-10px';
                el.style.left = Math.random() * 100 + 'vw';
                el.style.zIndex = '9999';
                el.style.pointerEvents = 'none';
                el.style.width = (Math.random() * 8 + 5) + 'px';
                el.style.height = (Math.random() * 8 + 5) + 'px';
                el.style.background = cols[Math.floor(Math.random() * cols.length)];
                el.style.borderRadius = Math.random() > 0.5 ? '50%' : '2px';

                el.style.animation = `confFall ${(Math.random() * 2 + 1.5)}s linear forwards`;
                el.style.opacity = Math.random() * 0.5 + 0.5;

                container.appendChild(el);

                setTimeout(() => {
                    if (el.parentNode) {
                        el.remove();
                    }
                }, 4000);
            }, i * 20);
        }
    }

    render() {
        //اگر هنوزلود نشده اند لودینک نشون بده
        if (this.state.segments.length === 0) {
            return (
                <div className="app" style={{ textAlign: 'center', marginTop: '50px', color: '#fff' }}>
                    <h2>...در حال دریافت اطلاعات گردونه</h2>
                    <p>⏳ لطفا چند لحظه صبر کنید</p>
                </div>
            );
        }

        return (
            <div className="app" style={{ textAlign: 'center' }}>


                {/* بکگراند متحرک */}
                <div className="scene">
                    <div className="stars"></div>
                    <div className="stars2"></div>
                    <div className="stars3"></div>
                    <div className="nebula nebula-1"></div>
                    <div className="nebula nebula-2"></div>
                    <div className="nebula nebula-3"></div>
                </div>




                <h1 className="h1">گردونه جرات حقیقی</h1>




                {/* کانتینر اصلی که گردونه و دکمه‌ها را کنار هم نگه می‌دارد */}
                <div className="main-container" style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '30px', /* فاصله بین دکمه‌ها و گردونه */
                    padding: '20px',
                    flex: 1,
                    width: '100%',
                }}>


                    <div className="left-cards">
                        <div
                            className="cat-btn-blu" style={{ borderLeft: ' 5px solid #1d13b4', }}
                        >
                            <img className="img-icon modal-img-animate" src={require('./icon/h2.png')} />
                            <div>حقیقت اسون</div>
                            <p style={{ fontSize: '10px', color: "#9a9999" }}>Easy Truth</p>
                            <button className="btns" style={{ background: '#78E8FF' }} > 📖 سوال ساده</button>
                        </div>

                        <div
                            className="cat-btn-red" style={{ borderLeft: ' 5px solid #ff3333', }}
                        >
                            <img className="img-icon modal-img-animate" src={require('./icon/h1.png')} />
                            <div>حقیقت سخت</div>
                            <p style={{ fontSize: '10px', color: "#9a9999" }}>Hard Truth</p>
                            <button className="btns" style={{ background: '#009BBA' }}  > 🎭 سوال عمیق </button>
                        </div>
                    </div>

                    <div className="canvas-btn" style={{ position: 'relative' }}>
                        {/* ===== اضافه کردن عقربه ===== */}
                        <div style={{
                            position: 'absolute',
                            top: '-22px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            zIndex: 15,
                            filter: 'drop-shadow(0 6px 10px rgba(0, 0, 0, 0.4))',
                            width: '44px',
                            height: '52px',
                        }}>
                            {/* مثلث پایین (نوک عقربه) */}
                            <div style={{
                                position: 'absolute',
                                left: '50%',
                                top: '0',
                                transform: 'translateX(-50%)',
                                width: '0',
                                height: '0',
                                borderLeft: '17px solid transparent',
                                borderRight: '17px solid transparent',
                                borderTop: '44px solid #ef4444',
                                borderRadius: '0 0 4px 4px',
                            }}></div>

                            {/* دایره بالای عقربه */}
                            <div style={{
                                position: 'absolute',
                                left: '50%',
                                top: '-8px',
                                transform: 'translateX(-50%)',
                                width: '18px',
                                height: '18px',
                                background: 'radial-gradient(circle at 40% 40%, #fca5a5, #dc2626)',
                                borderRadius: '50%',
                                zIndex: 2,
                                boxShadow: '0 0 10px rgba(239, 68, 68, 0.5)',
                            }}></div>
                        </div>
                        <canvas
                            ref={this.canvasRef}
                            width={450}
                            height={450}
                            style={{
                                borderRadius: '50%',
                                boxShadow: '0 0 20px rgba(255,255,255,0.1)'
                                ,
                                zIndex: '10',
                                width: ' 100%',
                                height: '100%',


                            }}
                        ></canvas>

                        <button
                            className="btn-circle"
                            onClick={this.spinWheel}
                            disabled={this.state.isSpinning}
                            style={{
                                position: 'absolute',
                                bottom: '-80px', /* دکمه بچرخون زیر گردونه */
                                left: '50%',
                                transform: 'translateX(-50%)',
                                padding: '10px 20px',
                                borderRadius: '20px',
                                background: '#DA22FF',
                                color: '#fff',
                                border: 'none',
                                cursor: 'pointer'
                            }}
                        >
                            {this.state.isSpinning ? 'در حال چرخش⏳' : 'بچرخون 🤸‍♂️'}
                        </button>
                        <LEDRing isSpinning={this.state.isSpinning} />


                    </div>

                    {/* ===== سمت راست: دکمه‌های جرأت ===== */}
                    <div className="right-cards" >
                        <div
                            className="cat-btn-red" style={{ borderRight: ' 5px solid #ff3333', }}
                        >
                            <img className="img-icon modal-img-animate" src={require('./icon/J2.png')} />
                            <div>جرات سخت</div>
                            <p style={{ fontSize: '10px', color: "#9a9999" }}>Hard Dare</p>
                            <button className="btns" style={{ background: '#FF0000' }} > 🔥 چالش آتشین</button>
                        </div>

                        <div
                            className="cat-btn-blu" style={{ borderRight: ' 5px solid #1d13b4', }}
                        >
                            <img className="img-icon modal-img-animate" src={require('./icon/J1.png')} />
                            <div>جرات آسون</div>
                            <p style={{ fontSize: '10px', color: "#9a9999" }}>Easy Dare</p>
                            <button className="btns" style={{ background: '#FF8400' }}> 💪 چالش ساده</button>
                        </div>
                    </div>

                </div>

                {/* مودال برنده  */}
                {this.state.showWinnerModal && (
                    <div className="modal-overlay" onClick={this.closeWinnerModal}>
                        <div className="modal-box" onClick={(e) => e.stopPropagation()}>

                            <img
                                className="modal-img modal-img-animate"
                                src={this.state.winnerIcon || require('./icon/J1.png')} />

                            <h5 className="h5" style={{ color: "#9a9999" }}>انجام بده وگرنه پرداخت کن</h5>
                            <p className="modal-text">{this.state.winnerQuestion}</p>
                            <div className="btns-modal">
                                <button className="modal-btn" onClick={this.closeWinnerModal}>
                                    <img style={{ width: '50px' }} src={require('./icon/111.png')} /> نفر بعدی
                                </button>
                                <button className="modal-btn" onClick={this.closeWinnerModal}>
                                    <img style={{ width: '50px' }} src={require('./icon/222.png')} /> پرداخت کن
                                </button>
                            </div>

                        </div>

                    </div>
                )}

                <div
                    ref={this.confettiContainer}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        pointerEvents: 'none',
                        zIndex: 9999,
                        overflow: 'hidden'
                    }}
                ></div>


            </div>
        )
    }

}
export default Wheel;